<template>
  <div class="pk-animationview">
    <div id="pk-animation-window" class="" >
    </div>
  </div>
</template>

<script>
import { PKAnimationFrameCreator } from '../utils/pk-animation-continuous-frames';
import { PKConfig } from '../config';
const pkConfig = require('../config.json');

export default {
  props: {
    inputData: {
      type: Object
    }
  },
  data() {
    return {
      startLoad: {
        done: false,
        threads: []
      },
      showLoading: false,
      pkaFrameCreator: undefined
    };
  },
  mounted() {
    const id = this.containerId;
    // console.log(id);
    this.createAnimation();
  },
  destroyed() {
    if (this.pkaFrameCreator && this.pkaFrameCreator.picturesData) {
      this.pkaFrameCreator.destroy();
    }
    for (const subscriber of this.startLoad.threads) {
      subscriber.unsubscribe();
    }
  },
  watch: {
    inputData() {
      this.createAnimation();
    }
  },
  computed: {
    containerId() {
      return this.$getRandomId();
    }
  },
  methods: {
    createAnimation() {
      if (this.pkaFrameCreator && this.pkaFrameCreator.picturesData) {
        this.pkaFrameCreator.destroy();
      }
      if (this.inputData) {
        this.pkaFrameCreator = new PKAnimationFrameCreator('pk-animation-window', this.inputData);
      }
    }
  }
};
</script>

<style>
  .pk-animationview {
    height: 100%;
    background-color: rgb(0, 0, 0);
  }

  #pk-animation-window {
    margin: 0 auto;
  }

</style>